import { motion } from "motion/react";

const steps = [
  {
    num: "1",
    title: "Nos llamas o escribes por WhatsApp",
    desc: "Contacto directo con técnico, sin centralita ni intermediarios.",
    delay: 0,
  },
  {
    num: "2",
    title: "Visita gratuita en 24h",
    desc: "Diagnóstico y presupuesto cerrado el mismo día de la visita.",
    delay: 0.1,
  },
  {
    num: "3",
    title: "Reparación o instalación",
    desc: "Solucionamos el 80% de averías en la primera visita técnica.",
    delay: 0.2,
  },
  {
    num: "4",
    title: "Garantía 2 años",
    desc: "Cubre piezas y mano de obra. Si algo falla, volvemos sin coste.",
    delay: 0.3,
  },
];

export default function HowWeWorkSection() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-3">
            Cómo trabajamos
          </h2>
          <div className="w-10 h-1 bg-primary rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {steps.map((step) => (
            <motion.div
              key={step.num}
              className="relative bg-surface-alt rounded-2xl p-6 md:p-8"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: step.delay }}
            >
              <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center font-heading font-extrabold text-xl mb-4">
                {step.num}
              </div>
              <h3 className="font-heading font-bold text-xl text-text-primary mb-2">
                {step.title}
              </h3>
              <p className="font-body text-base text-text-secondary leading-relaxed">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}